import { RouteObject, useLocation, useRoutes } from "react-router-dom";
import { FC, useContext } from "react";
import Sidebar from "Components/Layout/Sidebar";
import { UserContext } from "../Context/UserContextProvider";
import { useRouteCleanup } from "Hooks/useRouteCleanup";
import ErrorBoundary from "Components/ErrorBoundary";

type RoutingProps = {
    routes: RouteObject[]
}

const Routing: FC<RoutingProps> = ({ routes }) => {
    const { currentUser } = useContext(UserContext)
    const location = useLocation()
    useRouteCleanup()

    // Around the routed page rather than the whole app: a crash then blanks the page area only. Keyed on the
    // route so moving to another page clears the error.
    return (
        <>
            {currentUser && <Sidebar />}
            <ErrorBoundary resetKey={location.pathname + location.search}>
                {useRoutes(routes)}
            </ErrorBoundary>
        </>
    );
}

export default Routing;